export default function SpecialMenuwithTipo({ children }) {
  return <>{children}</>;
}
